import React from 'react'
import { CompanyStaffType } from 'types'
import { StaffCardContent } from '../styles'
import dayjs from 'dayjs'
import { openPopup } from 'components/ConfirmationPopups'

interface IProps {
  staff: CompanyStaffType
  expanded: boolean
}

export const StaffBoxCardContent = (props: IProps) => {
  const { expanded, staff } = props
  const birthPlace = staff.birthPlace
    ? `${staff.birthPlace.city}, ${staff.birthPlace.postal}, ${staff.birthPlace.country}`
    : ''
  const displayName = (nameData: any) =>
    nameData
      ? `${nameData.prefix || ''}, ${
          nameData.firstname || nameData.first || ''
        }, ${(nameData.lastname || nameData.last || '').toUpperCase()}`
      : ''

  const staffDisplayedName = displayName({
    prefix: staff.prefix,
    lastname: staff.lastname,
    firstname: staff.firstname,
  })

  const notifyClipboardCopied = () => {
    openPopup('Copié dans le presse-papier.', 'Vous pourrez le coller.', 2)
  }

  const copyToClipboard = (e: any, value: string | undefined) => {
    e.preventDefault()
    if (!value) return

    navigator.clipboard.writeText(value)
    notifyClipboardCopied()
  }

  return (
    <StaffCardContent>
      <li onClick={e => copyToClipboard(e, staffDisplayedName)}>
        {staffDisplayedName}
      </li>
      {staff.socialDenomination && (
        <li
          onClick={e => copyToClipboard(e, staff.socialDenomination)}
        >{`Raison sociale: ${staff.socialDenomination || ''}`}</li>
      )}
      <li onClick={e => copyToClipboard(e, staff.emailAddress)}>{`Email: ${
        staff.emailAddress || ''
      }`}</li>
      {staff.birthDate && expanded && (
        <li
          onClick={e =>
            copyToClipboard(
              e,
              staff.birthDate && dayjs(staff.birthDate).format('DD/MM/YYYY')
            )
          }
        >{`Né le: ${
          staff.birthDate && dayjs(staff.birthDate).format('DD/MM/YYYY')
        }`}</li>
      )}
      {staff.birthPlace && expanded && (
        <li onClick={e => copyToClipboard(e, `${birthPlace}`)}>
          {`Né à: ${birthPlace}`}
        </li>
      )}
      {staff.birthCountry && expanded && (
        <li
          onClick={e => copyToClipboard(e, staff.birthCountry)}
        >{`Pays de naissance: ${staff.birthCountry}`}</li>
      )}
      <li onClick={e => copyToClipboard(e, staff.nationality)}>{`Nationalité: ${
        staff.nationality || ''
      }`}</li>
      {staff.socialSecurityNumber && expanded && (
        <li
          onClick={e => copyToClipboard(e, staff.socialSecurityNumber)}
        >{`Num. Sécu.: ${staff.socialSecurityNumber || ''}`}</li>
      )}
      {staff.postalAddress && expanded && (
        <li onClick={e => copyToClipboard(e, staff.postalAddress)}>{`Adresse: ${
          staff.postalAddress || ''
        }`}</li>
      )}
      {staff.postalAddress && (
        <li>{`Cacher l'adresse: ${staff.hiddenAddress ? 'OUI' : 'non'}`}</li>
      )}
      {staff.father && expanded && (
        <li
          onClick={e => copyToClipboard(e, displayName(staff.father))}
        >{`Père: ${displayName(staff.father)}`}</li>
      )}
      {staff.mother && expanded && (
        <li
          onClick={e => copyToClipboard(e, displayName(staff.mother))}
        >{`Mère: ${displayName(staff.mother)}`}</li>
      )}
      {expanded && (
        <li>{`Statut matrimonial: ${staff.maritalStatus || ''}`}</li>
      )}
      <li onClick={e => copyToClipboard(e, staff.siren)}>{`Siren: ${
        staff.siren || ''
      }`}</li>
      {staff.socialPlace && expanded && (
        <li
          onClick={e => copyToClipboard(e, staff.socialPlace)}
        >{`Siège social: ${staff.socialPlace || ''}`}</li>
      )}
      {staff.socialCapital && expanded && (
        <li
          onClick={e => copyToClipboard(e, staff.socialCapital)}
        >{`Capital social: ${staff.socialCapital || ''}`}</li>
      )}
      {staff.greffe && expanded && (
        <li onClick={e => copyToClipboard(e, staff.greffe.name)}>{`Greffe: ${
          staff.greffe.name || ''
        }`}</li>
      )}
      {staff.role === 'shareholder' && (
        <li
          onClick={e => copyToClipboard(e, (staff.shares || '').toString())}
        >{`Actions: ${staff.shares || ''}`}</li>
      )}
    </StaffCardContent>
  )
}
